import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import config from "../config/config";

const FooterThree = () => {
  return (
    <>
      {/* ================== Footer Two Start ==================*/}
      <footer className='footer-area bg-black mt-0 pd-top-100'>
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              <div className='widget widget_about text-center'>
                <div className='thumb'>
                  <img src={config.PUBLIC_URL + 'assets/img/logo.png'} alt='img' />
                </div>
                <div className='details'>
                  <p><b style={{fontSize: `18px`}}>Krishna Steel Forge</b></p>
                  <p>
                    Forging Strength, Powering Excellence
                  </p><br/>
                  <p>info@krishnasteelforge.com</p>
                  <p>marketing@krishnasteelforge.com</p>
                  <p>+91 9265073148</p>
                  <ul className='social-media text-center'>
                    <li>
                      <Link to='#'>
                        <FaFacebookF />
                      </Link>
                    </li>
                    <li>
                      <Link to='#'>
                        <FaTwitter />
                      </Link>
                    </li>
                    <li>
                      <Link to='#'>
                        <FaInstagram />
                      </Link>
                    </li>
                    <li>
                      <Link to='https://www.youtube.com/@KrishnasteelForge' target="_blank">
                        <FaYoutube />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='footer-bottom bg-gray-black'>
          <div className='container'>
            <div className='row'>
              <div className='col-12 text-center align-self-center'>
                <p>Copyright © {new Date().getFullYear()} Krishna Steel Forge| All Rights Reserved</p>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* ================== Footer Two  end ==================*/}
    </>
  );
};

export default FooterThree;
